import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";
import { login, signout } from "../actions/auth_action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export const useAuthManager = () => {
  const {
    isLoading,
    isAuthenticated,
    getAccessTokenSilently,
    logout: auth0Logout,
    user,
  } = useAuth0();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isLoggedIn } = useSelector((state) => state.auth);
  const [isLogingin, setIsLogingin] = useState(false);

  const getAccessToken = async () => {
    if (isAuthenticated) {
      try {
        const token = await getAccessTokenSilently();
        // console.log("✅ Access token obtained silently: ", token);
        return token;
      } catch (error) {
        // console.log("❌ getAccessTokenSilently failed:", error);
      }
    } else {
      console.warn("⚠️ Tried getting token when not authenticated");
    }
    return null;
  };

  const logout = () => {
    localStorage.clear();
    dispatch(signout());
    navigate("/signin");
    // Call Auth0 logout
    // auth0Logout({
    //   logoutParams: { returnTo: window.location.origin },
    // });
  };

  useEffect(() => {
    // console.log("%c[Auth Debug]", "color: teal; font-weight: bold;");
    // console.log("isLoading:", isLoading);
    // console.log("isAuthenticated (Auth0):", isAuthenticated);
    // console.log("isLoggedIn (Redux):", isLoggedIn);
    // console.log("✅ isAuthenticated:", isAuthenticated);
    // console.log("👤 User:", user);

    if (isLoading) return;

    if (isAuthenticated && !isLoggedIn) {
      const run = async () => {
        const access_token = await getAccessToken();

        if (!access_token) {
          console.warn("[AuthManager] No access token available.");
          return;
        }

        setIsLogingin(true);
        dispatch(login(access_token, navigate));
        setIsLogingin(false);
      };

      run().catch((err) => {
        console.error("Error during login dispatch:", err);
        logout(); // fallback
      });
    }
  }, [isLoading, isAuthenticated, isLoggedIn, dispatch]);

  return {
    isLoading: isLoading || isLogingin,
    isAuthenticated: isAuthenticated && isLoggedIn,
    getAccessToken,
    logout,
  };
};
